<script setup lang="ts">
import { useScreen } from '@/composables/useScreen'

interface CertificateItem {
  icon: string
  title: string
  number: string
  href: string
  type?: string
}

const props = defineProps<{
  modelValue: CertificateItem[] | null
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: CertificateItem[] | null): void
}>()

const { isMobile } = useScreen()
</script>

<template>
  <v-modal :model-value="!!props.modelValue" title="Сертификаты" @update:model-value="() => emit('update:modelValue', null)">
    <h2 v-if="!isMobile" class="text-h3 mb-2 mr-3">Сертификаты</h2>
    <div class="d-flex flex-column">
      <v-menu-button v-for="cert in props.modelValue || []" :key="cert.number" :href="cert.href" target="_blank">
        <v-icon class="mr-2" size="24">{{ cert.icon }}</v-icon>

        <div class="d-flex flex-column">
          <span v-text="cert.title"></span>
          <span class="text-caption gray-text mt-half">
            <template v-if="cert.type"> {{ cert.type }}&nbsp;&centerdot;&nbsp; </template>
            {{ cert.number }}
          </span>
        </div>
      </v-menu-button>
    </div>
  </v-modal>
</template>
